import { useEffect, useState } from "react";
import { useClerk } from "@clerk/react";
import { toast } from "sonner";
import { UserCog } from "lucide-react";
import { useAuthedApi, errMsg } from "../../lib/api";
import { useUserLocation } from "../../lib/location";
import StateCitySelect from "../StateCitySelect";

export default function ProfileEditor({ me, onSaved }) {
  const api = useAuthedApi();
  const { openUserProfile } = useClerk();
  const { location, setLocation } = useUserLocation();
  const [f, setF] = useState({ name: me.name || "", phone: me.phone || "" });
  const [loc, setLoc] = useState({ state: location?.state || "", city: location?.city || "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { setLoc({ state: location?.state || "", city: location?.city || "" }); }, [location]);

  const save = async (e) => {
    e.preventDefault();
    if (f.phone && !/^\+?[0-9][0-9 -]{8,14}$/.test(f.phone)) return toast.error("Enter a valid mobile number");
    setBusy(true);
    try {
      const r = await api("put", "/me", f);
      if (loc.city && loc.city !== location?.city) setLocation(loc);
      onSaved({ ...me, ...r });
      toast.success("Profile updated");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <form onSubmit={save} className="lux-card p-6 space-y-4 max-w-2xl" data-testid="profile-form">
      <p className="eyebrow">Your profile</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><label className="lux-label">Full name</label><input className="lux-input" required maxLength={80} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="profile-name" /></div>
        <div><label className="lux-label">Mobile number</label><input className="lux-input" inputMode="tel" maxLength={15} value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="98XXXXXXXX" data-testid="profile-phone" /></div>
        <StateCitySelect state={loc.state} city={loc.city} prefix="profile-" onChange={(v) => setLoc({ ...loc, ...v })} />
      </div>
      <p className="text-xs text-gray-500">Email: {me.email || "—"} · Your name and number pre-fill new listings, offers and enquiries.</p>
      <div className="flex flex-wrap gap-3">
        <button className="btn-gold" disabled={busy} data-testid="profile-save">{busy ? "Saving..." : "Save profile"}</button>
        <button type="button" className="btn-outline" onClick={() => openUserProfile()} data-testid="profile-manage-account"><UserCog className="w-4 h-4" />Photo, email & password</button>
      </div>
    </form>
  );
}
